import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Hero from './components/Hero';
import LatestNews from './components/LatestNews';
import FeaturedWorks from './components/FeaturedWorks';
import PhotoGallery from './components/PhotoGallery';
import ProfilePreview from './components/ProfilePreview';
import FanResources from './components/FanResources';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '友田真希官方粉丝应援会',
  url: 'https://huanyung.cn/',
  description: '友田真希官方粉丝应援落地页，汇聚友田真希的最新动态、作品资讯、个人经历与粉丝应援资源。全面了解友田真希的魅力与艺能世界。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://huanyung.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '友田真希官方粉丝应援会',
  url: 'https://huanyung.cn/',
  description: '友田真希官方粉丝应援组织',
  foundingDate: '2015',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer support',
    email: 'support@huanyung.cn',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="首页"
        description="友田真希官方粉丝应援落地页，汇聚友田真希的最新动态、作品资讯、个人经历与粉丝应援资源。全面了解友田真希的魅力与艺能世界。"
        keywords="友田真希,友田真希 作品,友田真希 最新动态,友田真希 个人资料,友田真希 粉丝,友田真希 艺能活动,友田真希 写真"
        schema={{ ...homeSchema }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <Hero />
        <LatestNews />
        <FeaturedWorks />
        <PhotoGallery />
        <ProfilePreview />
        <FanResources />
      </main>
      <Footer />
    </>
  );
}